// extracted by mini-css-extract-plugin
module.exports = {"businessBefore":"businessBefore--JHjvm","text":"text--cZUGP"};